import type { ElementType } from 'react';
import type { FeatureFlags } from '../../config/featureFlags';
import { useFeatureFlags } from '../../contexts/FeatureFlagsContext';

interface Props {
  flag: keyof FeatureFlags;
  V1: ElementType;
  V2: ElementType;
}

export function FlaggedPage({ flag, V1, V2 }: Props) {
  const flags = useFeatureFlags();
  const Component = flags[flag] ? V2 : V1;
  return <Component />;
}
